// 第三方账户
import { third } from "./third";
// 账户设置
import { set } from "./set";
// 关联账号
import { relative } from "./relative";
// 生物识别
import { identify } from "./identify";
// 社交账号绑定
import { SocialLogin } from "./social";

export { third, set, relative, identify, SocialLogin };
